export default __webpack_public_path__ + "static/media/doctor-1.be073082.png";